export enum DeliveryTimeType {
    Exact = 'Exact',
    Asap = 'Asap',
    Window = 'Window',
}

export enum DeliveryTypeCategory {
    Delivery = 'Delivery',
    EatIn = 'EatIn',
    Takeaway = 'Takeaway',
}

export enum Channel {
    Menuboard = 'Menuboard',
    Web = 'Web',
    QR = 'QR',
    Kiosk = 'Kiosk',
    Foodora = 'Foodora',
    Wolt = 'Wolt',
    Pos = 'Pos',
    Phone = 'Phone',
    Tab = 'Tab',
}

export enum Phase {
    New = 'New',
    InProgress = 'InProgress',
    Future = 'Future',
    Archived = 'Archived',
}

export enum State {
    AwaitingAcceptance = 'AwaitingAcceptance',
    Accepted = 'Accepted',
    Production = 'Production',
    Ready = 'Ready',
    Delivering = 'Delivering',
    Delivered = 'Delivered',
    Cancelled = 'Cancelled',
}

export enum PaymentType {
    CardOnsite = 'CardOnsite',
    Cash = 'Cash',
    Invoice = 'Invoice',
    MealVoucher = 'MealVoucher',
    MealVoucherCard = 'MealVoucherCard',
    Online = 'Online',
}
